import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const phoneNumber = '+50688173167';
  const message = 'Hello! I would like to book a tour/transfer with Travel Guide Costa Rica.';
  const whatsappUrl = `https://wa.me/${phoneNumber.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float group"
      data-testid="whatsapp-button"
      aria-label="Contact us on WhatsApp"
    >
      <span className="floating-btn-label">WhatsApp</span>
      <MessageCircle className="w-7 h-7" />
    </a>
  );
};

export default WhatsAppButton;
